// ═══════════════════════════════════════════════════════════════════════
// Paramètres › Journal (Lot 1) : chaque acte sur une règle (préparation, simulation, soumission,
// validation, refus, annulation, packs), avec son auteur, sa date et son motif. Journal inaltérable.
// ═══════════════════════════════════════════════════════════════════════
import Layout from '../../components/Layout';
import { EnTetePage, BandeauInfo, EtatVide, Squelette } from '../../design/composants';
import { useChargement } from '../temps/reglagesCommun';
import { lireCfg, NavParametres, LIBELLES_ACTIONS_JOURNAL } from './configurationCommun';

const dateHeure = (d) => (d ? new Date(d).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' }) : '—');
function detail(l) {
  const n = l.nouvelles_valeurs || {};
  return [l.regle, n.valeur, n.date_debut ? `à partir du ${String(n.date_debut).split('-').reverse().join('/')}` : null,
    n.population !== undefined ? `${n.population} salarié(s), ${n.changes} changement(s)` : null].filter(Boolean).join(' · ');
}

export default function JournalConfigurationPage() {
  const { donnees, erreur } = useChargement(() => lireCfg('/journal', { limite: 200 }), []);
  return (
    <Layout>
      <div className="rh-page">
        <EnTetePage fil={[{ libelle: 'Paramètres', vers: '/parametres' }, { libelle: 'Journal' }]} titre="Journal des règles"
          sousTitre="Qui a préparé, simulé, validé, refusé ou retiré une règle, quand et pourquoi. Ce journal ne se modifie pas." />
        <NavParametres actif="journal" />
        {erreur && <BandeauInfo ton="danger">{erreur}</BandeauInfo>}
        {!donnees && !erreur && <Squelette hauteur={160} />}
        {donnees && donnees.length === 0 && <EtatVide titre="Journal vide" texte="Aucun acte sur les règles pour l'instant." />}
        {donnees && donnees.length > 0 && (
          <div className="rh-conteneur-tableau">
            <table className="rh-tableau">
              <thead><tr><th>Date</th><th>Acte</th><th>Par</th><th>Détail</th><th>Motif</th></tr></thead>
              <tbody>
                {donnees.map((l, i) => (
                  <tr key={`${l.created_at}-${i}`}>
                    <td>{dateHeure(l.created_at)}</td>
                    <td>{LIBELLES_ACTIONS_JOURNAL[l.action] || l.action}</td>
                    <td>{l.par || '—'}</td>
                    <td>{detail(l) || '—'}</td>
                    <td>{l.motif || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Layout>
  );
}
